import React from "react";

function KanbanIcon({ className }: { className: string }) {
  return (
    <svg className={className} viewBox="0 0 21 21">
      <rect width="10" height="10" rx="1" />
      <rect width="10" height="10" rx="1" transform="translate(0 11)" />
      <rect width="10" height="10" rx="1" transform="translate(11)" />
      <rect width="10" height="10" rx="1" transform="translate(11 11)" />
    </svg>
  );
}

export { KanbanIcon };
